// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"417":"c01590d4","569":"ef6c4822","787":"06182785"}[chunkId] + ".chunk.js";
};